<template>
  <div v-if="isFreeEvangelism" class="dashbaord-video">
    <div class="video-container" style="text-align: center">
      <h2>Upgrade Information</h2>
    </div>
    <br />
    <div class="video-container" style="text-align: center">
      <iframe src="https://player.vimeo.com/video/881023266?autoplay=1&loop=1" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" style="width: 100%; max-width: 640px"> </iframe>
    </div>
    <br />
    <div class="button-container" style="text-align: center">
      <a-button type="primary" @click="gotoCheckoutPage()" style="width: 150px">
        <span> Next </span>
      </a-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { includes } from 'lodash';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['settings', 'user']),
    isFreeEvangelism() {
      return includes(this.user.user.role, 'free_evangelism');
    },
  },
  methods: {
    gotoCheckoutPage() {
      this.$router.push({ path: '/upgrade-membership' });
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'signIn' });
    },
  },
};
</script>
